export const getPatientName = (patient) => {
  if (patient && patient !== undefined) {
    return patient.firstName + " " + patient.surname;
  }
  return "";
};
